import React from 'react';
import VastsDistributionChart from '../components/statistics/VastsDistributionChart';

export default function StatisticsPage() {
  return (
    <section className="content-section active">
      <div className="section-header">
        <div>
          <h2>Statistics &amp; Analytics</h2>
          <p>Visualize performance trends and export detailed reports</p>
        </div>
        {/* <button className="btn btn-secondary">Export Report</button> */}
      </div>

      <VastsDistributionChart />
    </section>
  );
}
